import $ from 'jquery';
import axios from "axios";

$(function() {

    // Temporarily disabled to allow page load optimisation

    initProductIndexPriceLookup();
    initProductIndexOrderItem();
    initModifyQuantityButtons();

    initFavouritesHideImages();
    initCampaignHideImages();

    initRemoveFavourite();

    initPopulateProductPrices();

});

// function initPopulateProductPrices() {

window.initPopulateProductPrices = function() {

    // Set the user specific prices for any products on the page
    //console.log('populate-product-prices');

    let products = [];
    $('[populate]').each(function() {
        products.push({
            productId: $(this).attr('data-product-id'),
            class: $(this).attr('class')
        });
    });

    if (products.length === 0) {
        return;
    }

    let productSlices = [];
    let sliceSize = 5;
    for (let s = 0; s < products.length; s += sliceSize) {
        productSlices.push(products.slice(s, (s + sliceSize)));
    }

    // Don't get caught out by the reuse of variable names - check scope

    // Try doing this is slices
    productSlices.forEach((products) => {
        axios.post('/products/populate-prices', {
            products: products
        }).then(function (response) {
            //console.log(response);
            if (response.data != '') {
                products.forEach((product) => {
                    let html = response.data[product.productId];
                    $('[populate][data-product-id="' + product.productId + '"][class="' + product.class + '"]').html(html);
                });
            }
        }).catch(function (error) {
            console.log(error);
        });
    });

    // // Try doing this item by item
    // products.forEach((product) => {
    //     axios.post('/products/populate-prices', {
    //         products: new Array(product)
    //     }).then(function (response) {
    //         //console.log(response);
    //         if (response.data != '') {
    //             products.forEach((product) => {
    //                 let html = response.data[product.productId];
    //                 $('[populate][data-product-id="' + product.productId + '"][class="' + product.class + '"]').html(html);
    //             });
    //         }
    //     }).catch(function (error) {
    //         console.log(error);
    //     });
    // });


    // return axios.post('/products/populate-prices', {
    //     products: products
    // }).then(function (response) {
    //     //console.log(response);
    //     if (response.data != '') {
    //         products.forEach((product) => {
    //             let html = response.data[product.productId];
    //             $('[populate][data-product-id="' + product.productId + '"][class="' + product.class + '"]').html(html);
    //         });
    //     }
    // }).catch(function (error) {
    //     console.log(error);
    // });

}


function initProductIndexPriceLookup() {

    //console.log('initProductIndexPriceLookup');

    let accountCode = $('#account-code').val();
    //console.log(accountCode);

    if (!accountCode) { return; }

    //console.log('accountCode: ' + accountCode);

    // Go through each product on the page and update the customer specific prices
    $('.tabproductpriceblock').each(function() {

        let $priceBlock = $(this);

        let stockId = $priceBlock.attr('data-stock-id');

        let data = {
            stock_id: stockId,
            account_code: accountCode,
            quantity: 1
        };
        let targetUrl = '/manager/settings/merlin/get-customer-price';
        axios.post(targetUrl, data).then(function (response) {
            //console.log(response);

            if (!response.data) {

                // Something went wrong - badly formatted result
                //console.log('The server returned badly formed data');
                //console.log(response);

            } else if (!response.data.product_code) {

                // The server returned an error of some sort
                //console.log('The server returned an error of some sort');
                //console.log(response);

            } else {
                // Let's assume for the moment we have well-formed data ...
                //console.log('The server returned well-formed data');
                //console.log($priceBlock);

                // Set the price
                // Check if this is a last chance page ...
                if ($priceBlock.find('.oldpricevalue').length) {
                    //console.log('last chance');
                    if (response.data.price < response.data.retail_price) {
                        $priceBlock.find('.currentpricevalue').text('£' + response.data.price.toFixed(2));
                    } else {
                        $priceBlock.find('.currentpricevalue').text('£' + response.data.retail_price.toFixed(2));
                    }
                    $priceBlock.find('.oldpricevalue').text('£' + response.data.list_price.toFixed(2));
                } else {
                    //console.log('not last chance');
                    $priceBlock.find('.currentpricevalue').text('£' + response.data.price.toFixed(2));
                }

                $priceBlock.removeClass('hide');
                // Check if we have any in stock
                if (!response.data.in_stock) {
                    // Set the out of stock flag
                    $priceBlock.find('.outofstockbadge').css('display', 'block');
                } else {
                    // Show the order panel
                    $priceBlock.find('.order-button').attr('data-price', response.data.price.toFixed(2));
                    $priceBlock.find('.tabproductadd').removeClass('hide');
                }

            }

        })["catch"](function (error) {
            console.log(error);
        });

    });

}


function initProductIndexOrderItem() {

    //console.log('initProductIndexOrderItem');

    $('.ajax-order-form .order-button').unbind('click');
    $('.ajax-order-form .order-button').on('click', function() {

        //console.log('order-button:click');

        let quantity = $(this).closest('.ajax-order-form').find('input.order-quantity').val();
        let productVariantId = $(this).attr('data-product-variant-id');
        let price = $(this).attr('data-price');

        //console.log(productVariantId, quantity, price);

        let data = {
            productVariantId: productVariantId,
            itemQuantity: quantity,
            itemPrice: price
        };
        let targetUrl = '/manager/ecommerce/basket/add-item';
        axios.post(targetUrl, data).then(function (response) {
            //console.log(response);

            if (!response.data) {
                // Something went wrong - badly formatted result
                //console.log('The server returned badly formed data');
                //console.log(response);
            } else {
                // Update the basket total
                // $('#basket-count').text('(' + response.data.basket_item_count + ')');
                $('#basket-count').text(response.data.basket_item_count);
                $('#current_basket_count').removeClass('hide');

                //alert('Your basket has been updated');

                showAlert('Alert', 'Your basket has been updated', '', 2);

                // Update the mini basket, if present
                updateMiniBasket(response.data);
                // Update the full basket if present
                customUpdateBasket(response.data);
            }

        })["catch"](function (error) {
            console.log(error);
        });

    });

}


function updateMiniBasket(basketDetails) {

    // Check if the mini basket is present
    if (!$('.tbl-basketmini').length) {
        return;
    }

    let currencySymbol = basketDetails.currency_symbol;
    let $miniBasket = $('<table cellPadding="0" cellSpacing="0" class="tbl-basketmini"><tbody></tbody></table>');

    basketDetails.items.forEach((item) => {
        $miniBasket.find('tbody').append($([
            '<tr>',
            '<td><span>' + item.quantity + ' x ' + item.title + '</span><br>' + item.size + ' ' + item.abv + '</td>',
            '<td>' + currencySymbol + item.item_gross + '</td>',
            '<tr>'
        ].join('')));
    });

    $miniBasket.find('tbody').append($('<tr><td class="basketminilbl">Subtotal:</td><td class="basketminittl">' + currencySymbol + basketDetails.item_total + '</td></tr>'));
    if (basketDetails.shipping_gross) {
        $miniBasket.find('tbody').append($('<tr><td class="basketminilbl">Shipping:</td><td class="basketminittl">' + currencySymbol + basketDetails.shipping_gross + '</td></tr>'));
    }
    $miniBasket.find('tbody').append($('<tr><td class="basketminilbl">VAT:</td><td class="basketminittl">' + currencySymbol + basketDetails.net_tax + '</td></tr>'));
    $miniBasket.find('tbody').append($('<tr><td class="basketminilbl">Gross Total:</td><td class="basketminittl">' + currencySymbol + basketDetails.net_total + '</td></tr>'));

    $('.tbl-basketmini').replaceWith($miniBasket);

    if (basketDetails.items.length) {
        $('.btn-continue').removeClass('hide');
    } else {
        $('.btn-continue').addClass('hide');
    }

}


function customUpdateBasket(basketDetails) {

    // Check if the basket is present
    if (!$('.tblbasket').length) {
        return;
    }

    let currencySymbol = basketDetails.currency_symbol;
    let $basket = $('.tblbasket');

    basketDetails.items.forEach((item) => {
        let $basketItemRow = $basket.find('tr[data-basket-item-id="' + item['item_id'] + '"]').first();
        if ($basketItemRow.length > 0) {
            $basketItemRow.find('.basket-item-quantity').val(item['quantity']);
            $basketItemRow.find('.basket-item-gross').text(' ' + currencySymbol + item['item_gross'] + ' ');
        } else {
            let $itemRow = $('<tr data-basket-item-id="' + item['item_id'] + '">' +
                '<td class="basketdel"><i class="fa-regular fa-trash-can basket-item-delete" data-basket-item-id="' + item['item_id'] + '"></i></td>' +
                '<td class="">' + item['product_code'] + '</td>' +
                '<td class=""><a href="' + item['title'] + '">' + item['title'] + '</a></td>' +
                '<td class="size">' + item['size'] + '</td>' +
                '<td class="abv">' + item['abv'] + '</td>' +
                '<td class="basketrt basket-item-price-excluding-tax"> ' + currencySymbol + item['price_array']['price_excluding_tax'] + ' </td>' +
                '<td class="basketrt"><input type="number" class="basketqty basket-item-quantity" data-basket-item-id="' + item['item_id'] + '" value="' + item['quantity'] + '"></td>' +
                '<td class="basketttl basket-item-gross"> ' + currencySymbol + item['item_gross'] + ' </td>' +
                '</tr>');
            let $subtitleRow = $basket.find('#basket-item-total').parent();
            $itemRow.insertBefore($subtitleRow);
        }
    });

    $basket.find('#basket-item-total').text(' ' + currencySymbol + basketDetails.item_total + ' ');
    $basket.find('#basket-discount').text(' ' + currencySymbol + basketDetails.discount + ' ');
    if (basketDetails.discount_num == 0) {
        $basket.find('#basket-discount').addClass('basket-hidden');
    } else {
        $basket.find('#basket-discount').removeClass('basket-hidden');
    }
    $basket.find('#basket-shipping').text(' ' + currencySymbol + basketDetails.shipping_gross + ' ');
    if (basketDetails.shipping_gross_num == 0) {
        $basket.find('#basket-shipping').addClass('basket-hidden');
    } else {
        $basket.find('#basket-shipping').removeClass('basket-hidden');
    }
    $basket.find('#basket-net-tax').text(' ' + currencySymbol + basketDetails.net_tax + ' ');
    $basket.find('#basket-net-total').text(' ' + currencySymbol + basketDetails.net_total + ' ');

}


function initModifyQuantityButtons() {

    //console.log('initModifyQuantityButtons');

    $('.modify-quantity').unbind('click');
    $('.modify-quantity').on('click', function() {

        let $container = $(this).parent();
        let $quantity = $container.find('.quantity');
        let val = $quantity.val();

        if ($(this).hasClass('increase')) {
            val++;
        } else if ($(this).hasClass('decrease')) {
            val--;
        }
        if (val < 0) {
            val = 0;
        }

        $quantity.val(val);

    });

}


function initFavouritesHideImages() {

    $('#favourites-hide-images').unbind('change');
    $('#favourites-hide-images').on('change', function() {
        let url = window.location.href.split('?')[0];
        if ($(this).is(':checked')) {
            // Need to reload without images
            window.location.href = url + '?hi';
        } else {
            window.location.href = url;
        }
    });

}


function initRemoveFavourite() {

    $('.remove-favourite').unbind('click');
    $('.remove-favourite').on('click', function() {

        let productVariantId = $(this).attr('data-product-variant-id');

        let url = window.location.pathname;
        let queryParams = new URLSearchParams(window.location.search);
        queryParams.set('remove', productVariantId);
        window.location.href = url + '?' + queryParams.toString();

    });

}


function initCampaignHideImages() {

    $('#campaign-hide-images').unbind('change');
    $('#campaign-hide-images').on('change', function() {
        let url = window.location.href.split('?')[0];
        if ($(this).is(':checked')) {
            // Need to reload without images
            window.location.href = url + '?hi';
        } else {
            window.location.href = url;
        }
    });

}
